const FR_COMPOSE_PLACEHOLDERS = [
  'Qu’avez-vous en tête ?',
  'Allez dis nous tout, je sens que t\'en a gros sur la patate',
  'Ceci est mon pouet',
  'Quelle belle journée nesspa?',
  'go!',
  'Allez viens on est bien',
  'Fais z\'y voir',
  'Il était une fois',
];

export function getRandomComposePlaceholder(intl, currentPlaceholder = null) {
  if (intl.locale?.startsWith('fr')) {
    const pool = currentPlaceholder
      ? FR_COMPOSE_PLACEHOLDERS.filter((placeholder) => placeholder !== currentPlaceholder)
      : FR_COMPOSE_PLACEHOLDERS;
    const index = Math.floor(Math.random() * pool.length);
    return pool[index];
  }

  return intl.formatMessage({ id: 'compose_form.placeholder', defaultMessage: 'What is on your mind?' });
}
